<div class="root-container">
  @if (imgPreview && withPreview()) {
    <div class="preview">
      <img [src]="imgPreview" alt="">
      <div class="close-btn" (click)="clearPreview()">
        <i class="bi bi-x-lg"></i>
      </div>
    </div>
  }
  @else {
    <div
      class="dropbox"
      [ngClass]="{ filesDragging: filesDragging() }"
      (dropFiles)="onDropFiles($event)"
      [(filesDragging)]="filesDragging"
      [multiple]="multiple()"
      [supportedFormats]="accepts()"
      [maxFileSize]="maxFileSize()"
      image-dropbox
    >
    <i class="bi bi-upload"></i>
    <p>Drag and drop or <span id='drop-link'>choose a file</span></p>
  </div>
  }
</div>
